import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'
import { useAdmin, useAdminLogin } from '../admin.ts'
import { ApiError } from '../lead.ts'
import { AdminDashboard } from '../screens/admin/dashboard.tsx'

type AdminSearch = { token?: string }

export const Route = createFileRoute('/admin')({
  validateSearch: (search: Record<string, unknown>): AdminSearch =>
    typeof search.token === 'string' && search.token ? { token: search.token } : {},
  component: AdminRoute,
})

/** M6: panel dla zarządu Tutlo. Wejście linkiem z sekretem `?token=` → cookie `tb_admin` na 30 dni (D12). */
function AdminRoute() {
  const { token } = Route.useSearch()
  const navigate = useNavigate()
  const admin = useAdmin()
  const login = useAdminLogin()
  const loginMutate = login.mutate

  // Token znika z URL po zalogowaniu — nie zostaje w historii/zakładce.
  useEffect(() => {
    if (!token) return
    loginMutate(
      { token },
      { onSettled: () => navigate({ to: '/admin', search: {}, replace: true }) },
    )
  }, [token, loginMutate, navigate])

  if (admin.isPending || login.isPending || token) {
    return <Center>Ładowanie…</Center>
  }
  if (!admin.data) {
    return (
      <Center>
        <h1 className="text-h2">Panel analityki Tutlo</h1>
        <p className="mt-md text-body text-text-secondary">{loginMessage(login.error)}</p>
      </Center>
    )
  }
  return <AdminDashboard />
}

function loginMessage(error: unknown): string {
  if (!error) {
    return 'Dostęp przez link z kluczem. Poproś zespół CYB o link do panelu.'
  }
  if (error instanceof ApiError && error.code === 'admin_disabled') {
    return 'Panel jest wyłączony na tym środowisku (brak ADMIN_LINK_SECRET w konfiguracji API).'
  }
  return 'Ten link jest nieprawidłowy. Poproś zespół CYB o aktualny link do panelu.'
}

function Center({ children }: { children: React.ReactNode }) {
  return (
    <main className="mx-auto flex min-h-dvh max-w-[480px] flex-col justify-center px-base text-body">
      {children}
    </main>
  )
}
